/** @jsx jsx */

import React, { ReactElement, useContext, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import Btn from './CarouselBtn';
import Marker from './CarouselMarker';
import { VisuallyHidden } from 'components/UI/VisuallyHidden';
import { colors, getButtonFocus } from 'styles/variables';
import { unlockInteraction } from 'services/unlockInteraction';
import { interactionContext as _interactionContext } from './interactionContext';
import { CarouselContext } from './Carousel';
import isEDGE from 'services/isEDGE';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

enum Direction {
  Prev = 'prev',
  Next = 'next',
}

// document.addEventListener('keyup', e => {
//   if (e.key !== 'Tab') {
//     return;
//   }

//   const activeElement = document.activeElement;

//   console.log({ activeElement });
// });

const CarouselLayout = ({ children }) => {
  const interactionContext = useContext(_interactionContext);
  const carouselContext = useContext(CarouselContext);
  const { previousIndex, currentIndex, animate } = carouselContext;
  const imgHeight = 350;

  const {
    carouselColor = '#fff',
    carouselTextColor = lGrey0,
    animation = 'natural',
  } = interactionContext.props;

  const { layout } = interactionContext.meta;

  const itemsSeen = useRef(
    unlockInteraction(interactionContext.id, (children as any).length)
  );

  useEffect(() => {
    if (window.dev()) return;
    if (interactionContext.props.lockDown === 0) return;
    itemsSeen.current(currentIndex);
  });

  // removed focus of
  // &:focus {
  //   ${getButtonFocus(
  //     !['#fff', '#ffffff', 'rgb(255, 255, 255)'].includes(carouselColor)
  //       ? carouselColor
  //       : lGrey0,
  //     `5px 10px 20px 10px rgba(0, 0, 0, 0.05)`
  //   )}
  // }

  // tabIndex={-1}

  return (
    <div
      css={css`
        width: 100%;
        padding: 10px 30px;
      `}
    >
      <div
        css={css`
          position: relative;
          width: 100%;
          background: ${carouselColor};
          border: 1px solid ${lGrey2};
          border-radius: 10px;
          box-shadow: 5px 10px 20px 10px rgba(0, 0, 0, 0.05);
          overflow: hidden;
        `}
        tabIndex={-1}
      >
        <ul
          css={css`
            display: flex;
            width: 100%;
            height: auto;
            margin: 0;
            padding: 0 !important;
            overflow: hidden;

            ${isEDGE() &&
              !['OneColumn', 'OneColumnReversed'].includes(layout) &&
              `
              max-width: 490px;
        
            `}
          `}
          tab-index={-1}
        >
          {(children as any).map((slide, index) =>
            React.cloneElement(slide, {
              index,
              currentIndex,
              animate,
              imgHeight,
              carouselColor,
              carouselTextColor,
              animation,
              slide,
            })
          )}
        </ul>

        <span className="sr-only">
          Showing slide {currentIndex + 1} of {children.length}:
        </span>

        <div
          css={css`
            position: absolute;
            display: flex;
            justify-content: center;
            width: 100%;
            top: ${imgHeight - 25}px;
          `}
        >
          <div
            css={css`
              display: flex;
            `}
          >
            {children.map((child, i) => (
              <Marker
                key={`marker-${i}`}
                index={i}
                current={currentIndex === i}
              />
            ))}
          </div>
        </div>

        <Btn
          dir={Direction.Prev}
          size={40}
          top={`${imgHeight / 2}px`}
          height={imgHeight}
          enabled={currentIndex > 0}
          onClick={carouselContext[Direction.Prev]}
        />
        <Btn
          dir={Direction.Next}
          size={40}
          top={`${imgHeight / 2}px`}
          height={imgHeight}
          enabled={currentIndex < React.Children.count(children) - 1}
          onClick={carouselContext[Direction.Next]}
        />
      </div>
    </div>
  );
};

export default CarouselLayout;
